import { cn } from "../../lib/cn";
import { useDashboardFilters } from "../../lib/dashboardFilters";
import { RANGE_PRESETS } from "../../lib/dateRangePresets";

// De-crowd preset chips wired to the dashboard's effective date window
// (L0-U16). The active chip and the month-to-date default are resolved
// synchronously by the dashboard filter context, so the bar never flashes "All"
// before settling on the default. A hand-picked range from the toolbar leaves no
// chip highlighted ("custom").
export function DateRangePresetBar() {
  const { activePreset, selectPreset } = useDashboardFilters();

  return (
    <div
      role="group"
      aria-label="Date range presets"
      className="flex flex-wrap items-center gap-1"
    >
      {RANGE_PRESETS.map((preset) => {
        const isActive = activePreset === preset.key;
        return (
          <button
            key={preset.key}
            type="button"
            aria-pressed={isActive}
            onClick={() => selectPreset(preset.key)}
            className={cn(
              "rounded-control border px-2.5 py-1 text-xs font-medium transition-colors",
              isActive
                ? "border-primary bg-primary text-on-primary"
                : "border-outline-variant bg-surface text-on-surface-variant hover:bg-surface-container-high hover:text-on-surface",
            )}
          >
            {preset.label}
          </button>
        );
      })}
    </div>
  );
}
